import { render, staticRenderFns } from "./FilesViewerDialog.vue?vue&type=template&id=42b52f06&scoped=true"
import script from "./FilesViewerDialog.vue?vue&type=script&lang=js"
export * from "./FilesViewerDialog.vue?vue&type=script&lang=js"
import style0 from "./FilesViewerDialog.vue?vue&type=style&index=0&id=42b52f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b52f06",
  null
  
)

export default component.exports